import React from "react";
import { cn } from "@/lib/utils";

/**
 * Inline GIF / MP4 attachment in a DM bubble.
 */
export default function DmGifAttachment({ attachment, className }) {
  if (!attachment || attachment.type !== "gif" || !attachment.url) {
    return null;
  }

  const title = attachment.title || "GIF";
  const mp4 = attachment.mp4_url;
  const src = mp4 || attachment.url;
  const w = attachment.width;
  const h = attachment.height;
  const aspect =
    w && h && Number(w) > 0 && Number(h) > 0
      ? { aspectRatio: `${w} / ${h}` }
      : undefined;

  return (
    <div
      className={cn(
        "mt-1 max-w-[280px] overflow-hidden rounded-md bg-black/5",
        className
      )}
      style={aspect}
    >
      {mp4 ? (
        <video
          src={src}
          poster={attachment.preview_url || undefined}
          autoPlay
          loop
          muted
          playsInline
          className="block w-full h-auto max-h-48 md:max-h-64 object-contain"
          title={title}
          aria-label={title}
        />
      ) : (
        <img
          src={src}
          alt={title}
          className="block w-full h-auto max-h-48 md:max-h-64 object-contain"
          loading="lazy"
        />
      )}
    </div>
  );
}
